// extracted by mini-css-extract-plugin
export default {"home-main":"Home_home-main__7mQAm","home_title":"Home_home_title__zS27L"};